module.exports = "<span *ngIf=\"label\" class=\"g-fs-13 g-fw-medium\">{{ label }}</span>\n<ng-content></ng-content>"